export default __webpack_public_path__ + "static/media/logo-celg.a2090f49.png";